import { ApPayeeDetailAllOfPaymentMethod } from 'ap-openapi';

type ForeignCurrencyDisableProps = {
  isForeignCurrencyFlag: boolean;
  paymentMethod?: ApPayeeDetailAllOfPaymentMethod;
  currency?: string;
};

export const isForeignCurrencyDisable = ({
  isForeignCurrencyFlag,
  paymentMethod,
  currency,
}: ForeignCurrencyDisableProps) => {
  const isBankTransfer = paymentMethod === 'bank_transfer';
  const isDisabled =
    !isBankTransfer &&
    isForeignCurrencyFlag &&
    currency !== undefined &&
    currency !== null &&
    currency !== 'JPY';
  return isDisabled;
};

export const getForeignCurrencyDisableProps = ({
  isForeignCurrencyFlag,
  paymentMethod,
  currency,
}: ForeignCurrencyDisableProps) => {
  return {
    disabled: isForeignCurrencyDisable({
      isForeignCurrencyFlag,
      paymentMethod,
      currency,
    }),
  };
};
